<template>
	<transition name="fade">
		<div class="tooltip" v-show="tooltip.display">
			<div class="tooltip-content panel">
				<h1 class="panel-heading" v-text="tooltip.title"></h1>
				<div class="panel-block">
					<p>{{ tooltip.description }}</p>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		computed: {
			tooltip() { return this.$store.state.main.tooltip }
		}
	}
</script>

<style lang="scss" scoped>
	.tooltip {
		display: flex;
		position: fixed;
		top: 0; //83
		right: 0;
    width: calc(100% - 310px);
    height: 100%;
    background-color: rgba(10,10,10,.4);
	}
	.tooltip-content {
		color: black;
		width: 75%;
		background-color: white;
		margin: auto;
	}
	.panel-heading {
		background-color: #8AC;
		color: #fff;
	}
	.panel-block {
		background-color: #fff;
	}
  .fade-enter-active {
    transition: all 1s ease;
  }
  .fade-leave-active {
    transition: all 1s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  @media screen and (min-width: 1600px) {
  	.tooltip {
  		width: calc(100% - 380px);
  	}
  	.tooltip-content {
  		width: 50%;
  	}
  }

</style>
